import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const { exchangeSession, setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const next = sessionStorage.getItem("ozono_next") || "/cuenta/panel";
    sessionStorage.removeItem("ozono_next");
    exchangeSession(sessionId)
      .then((u) => {
        toast.success(`¡Hola, ${u.name?.split(" ")[0] || "de nuevo"}!`);
        navigate(next, { replace: true, state: { user: u } });
      })
      .catch((err) => {
        console.error("Google session exchange failed", err);
        setUser(false);
        toast.error("No se pudo iniciar sesión. Inténtalo de nuevo.");
        navigate("/cuenta", { replace: true });
      });
  }, [exchangeSession, navigate, setUser, location.hash]);

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Loader2 className="h-10 w-10 text-cyan-500 animate-spin" />
      <p className="text-slate-600 text-sm">Iniciando sesión...</p>
    </div>
  );
};
